// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.config-area[data-v-4c794d54] {\n    padding: 0.2em 1.5em 1.5em 1.5em;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/modules/DataVariables/components/Validation.vue"],"names":[],"mappings":";AACA;IACI,gCAAgC;AACpC","sourcesContent":["\n.config-area[data-v-4c794d54] {\n    padding: 0.2em 1.5em 1.5em 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
